import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
    component: Home,
    children: [
      {
        path: "login",
        component: () => import("@/views/login/Login.vue"),
        meta: { title: "企业登录 - 三特系统" }
      },
      {
        path: "register",
        component: () => import("@/views/register/Register.vue"),
        meta: { title: "企业注册 - 三特系统" }
      },
      {
        path: "forget",
        component: () => import("@/views/forget/Forget.vue"),
        meta: { title: "找回登录密码 - 三特系统" }
      },
      {
        path: "privacy-policy",
        component: () => import("@/views/privacy-policy/PrivacyPolicy.vue"),
        meta: { title: "隐私协议 - 三特系统" }
      },
      {
        path: "use-agreement",
        component: () => import("@/views/privacy-policy/UseAgreement.vue"),
        meta: { title: "使用协议 - 三特系统" }
      },
      {
        path: "privacy-agreement",
        component: () => import("@/views/privacy-policy/PrivacyAgreement.vue"),
        meta: { title: "隐私协议 - 三特系统" }
      },
      {
        path: "coordination-use-agreement",
        component: () => import("@/views/privacy-policy/ComUseAgreement.vue"),
        meta: { title: "使用协议 - 三特协同系统" }
      },
      {
        path: "coordination-privacy-agreement",
        component: () => import("@/views/privacy-policy/ComPrivacyAgreement.vue"),
        meta: { title: "隐私协议 - 三特协同系统" }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };

export default router;
